/**
 * @scada/api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.29.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PlantDataItemResponse { 
    inverterId: string;
    stationCode: string;
    totalIncome: number;
    dayIncome: number;
    totalPower: number;
    dayPower: number;
    monthPower: number;
    currentYield: number;
    stationStatus: string;
    co2?: string;
    coal?: string;
    trees?: string;
    lastUpdatedCurrentYield?: string;
}

